<div>
  <button
    tuiButton
    [appearance]="'primary'"
    [class.default]="liveLocationStatus === 'default'"
    [class.failed]="liveLocationStatus === 'failed'"
    [class.loading]="liveLocationStatus === 'loading'"
    [class.success]="liveLocationStatus === 'success'"
    [class]="class"
    [disabled]="disabled"
    [icon]="icon"
    [iconRight]="iconRight"
    [nativeId]="id"
    [shape]="shape"
    [showLoader]="showLoader"
    [size]="size"
    [style]="styles"
    [type]="'button'"
    (click)="handleOnClick($event)"
  >
    {{ label }}
  </button>
</div>
